export default __webpack_public_path__ + "42ef7d40a7db6a9b89e28cf950c75af4.png";